var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"weight-600 fs13 cl-white bg-cl-special-offer brdr-8px py4 px12 text-nowrap"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }